import React from 'react';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const Privacy = () => (
  <div className="max-w-4xl mx-auto px-6 py-20 prose dark:prose-invert">
    <h1 className="font-serif text-4xl mb-8">Privacy Policy</h1>
    <p className="text-slate-500">Last Updated: May 20, 2024</p>
    <section className="mt-12 space-y-6">
      <h2 className="text-2xl font-bold">1. Data Collection</h2>
      <p>At Big Hook Media Inc., we prioritize your creative privacy. Weaver collects minimal personal data: account information and story content strictly for the purpose of session persistence and AI narrative generation.</p>
      <h2 className="text-2xl font-bold">2. Story Privacy</h2>
      <p>Your stories belong to you. We do not use your creative content to train public AI models without explicit consent. Local storage is used to maintain session state on your device.</p>
      <h2 className="text-2xl font-bold">3. Contact</h2>
      <p>For privacy inquiries, contact <strong>support@bighookmedia.com</strong>.</p>
    </section>
  </div>
);

export default Privacy;